export default __webpack_public_path__ + "static/media/Delete.166c33fd.svg";